import * as React from "react";
import styled, { css } from "styled-components";
import usePluginEntities from "hooks/usePluginEntities";
import BulkSelectCell from "components/common/message/messagetable/BulkSelectCell";
import MessageFieldRow from "./MessageFieldRow";
const TableRow = styled.tr(
  ({ theme }) => css`
    && {
      cursor: pointer;

      td {
        border-top: 0;
        padding-top: 0;
        padding-bottom: 4px;
        font-family: ${theme.fonts.family.monospace};
        color: ${theme.colors.variant.dark.info};
      }
    }
  `
);
const renderMessageFieldRow = (message, messageFieldType) => /* @__PURE__ */ React.createElement(MessageFieldRow, { message, messageFieldType });
const MessagePreview = ({
  onRowClick,
  colSpanFixup,
  message,
  messageFieldType,
  showMessageRow = false,
  config,
  displayBulkSelectCol
}) => {
  var _a;
  const MessageRowOverride = (_a = usePluginEntities("views.components.widgets.messageTable.messageRowOverride")) == null ? void 0 : _a[0];
  return showMessageRow && /* @__PURE__ */ React.createElement(TableRow, { onClick: onRowClick }, displayBulkSelectCol && /* @__PURE__ */ React.createElement(BulkSelectCell, null), /* @__PURE__ */ React.createElement("td", { colSpan: colSpanFixup }, !!MessageRowOverride && /* @__PURE__ */ React.createElement(
    MessageRowOverride,
    {
      messageFields: message.fields,
      config,
      renderMessageRow: () => renderMessageFieldRow(message, messageFieldType)
    }
  ), !MessageRowOverride && renderMessageFieldRow(message, messageFieldType)));
};
export default MessagePreview;
